import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function ImportBeneficiaryModal({ show, handleClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  const handleFileChange = (e) => {
    const selected = e.target.files && e.target.files[0];
    if (!selected) {
      setFile(null);
      return;
    }
    const allowedExtensions = ["xlsx", "xls", "csv"];
    const name = selected.name || "";
    const ext = name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(ext)) {
      toast.warn("Only .xlsx, .xls, .csv files are supported.");
      e.target.value = ""; // reset the input
      setFile(null);
      return;
    }
    setFile(selected);
  };

  const handleImport = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.warn("Please select a file to upload.");
      return;
    }
    // Double-check file extension before upload
    const allowedExtensions = ["xlsx", "xls", "csv"];
    const ext = (file.name || "").split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(ext)) {
      toast.warn("Only .xlsx, .xls, .csv files are supported.");
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${API_URL}/import-beneficiaries.php`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        toast.success("Beneficiaries imported successfully!");
        onSuccess();
      } else {
        toast.error(response.data.message || "Failed to import file.");
      }
    } catch (error) {
      toast.error("An error occurred during file import.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Import Beneficiaries from Excel</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleImport}>
        <Modal.Body>
          <p>
            Please upload an Excel file (.xlsx, .xls, .csv) with the following
            columns:{" "}
            <strong>
              Beneficiary_code, financial_year, ward_no, Beneficiary_name,
              Beneficiary_fathername
            </strong>
            .
          </p>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select File</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
            accept=".xlsx,.xls,.csv"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" /> Importing...
              </>
            ) : (
              "Import"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ImportBeneficiaryModal;
